import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-po-dashboard',
  templateUrl: './po-dashboard.component.html',
  styleUrls: ['./po-dashboard.component.scss']
})
export class PoDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
